import { Container, Flex, Button } from "@maxhub/max-ui"

export const ContainerExample = {
    title: 'Container',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'fullWidth',
            label: 'fullWidth',
            type: 'boolean',
            tsType: 'boolean',
            default: false,
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
    ],

    Preview({ props }){
        const { fullWidth, ...rest } = props
        return (
            <div style={{ width: '100%', alignSelf: 'stretch' }}>
                <Container fullWidth={fullWidth} {...rest}>
                    <Flex
                        direction="column"
                        gap={12}
                        style={{ width: '100%' }}
                    >
                        <Button
                            variant="secondary"
                            size="large"
                            stretched
                        >
                            Кнопка
                        </Button>
                        <Button
                            variant="secondary"
                            size="large"
                            stretched
                        >
                            Кнопка 2
                        </Button>
                    </Flex>
                </Container>
            </div>
        )
    },

    getCode(){
        return `<Container>
  <Flex
    direction="column"
    gap={12}
  >
    <Button
      variant="secondary"
      size="large"
      stretched
    >
      Кнопка
    </Button>
    <Button
      variant="secondary"
      size="large"
      stretched
    >
      Кнопка 2
    </Button>
  </Flex>
</Container>`
    }

}